import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorService } from '@cosmos/angular/utils';
import { OnboardingFlowDef } from '@cosmos/shared';
import { catchError, map, Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class OnboardingHttpService {
  constructor(
    private readonly http: HttpClient,
    private readonly errorService: ErrorService,
  ) {}

  getFlowById(flowId: string): Observable<HttpResponse<OnboardingFlowDef>> {
    return this.http
      .get<OnboardingFlowDef>(`${environment.API_URL}/onboarding/flows/${flowId}`, { observe: 'response' })
      .pipe(
        map(response => response),
        catchError(error => { this.errorService.handleError(error); throw error; }),
      );
  }

  getAllFlows(): Observable<HttpResponse<OnboardingFlowDef[]>> {
    return this.http
      .get<OnboardingFlowDef[]>(`${environment.API_URL}/onboarding/flows`, { observe: 'response' })
      .pipe(
        map(response => response),
        catchError(error => { this.errorService.handleError(error); throw error; }),
      );
  }
}
